import decode from 'jwt-decode';
import config from '../config';
import axios from 'axios';

export default class AuthService {
    constructor(domain) {
        this.debugMode = "";
        if (config.isDebugMode) {
            this.debugMode = "?XDEBUG_SESSION_START=PHPSTORM";
        }
        this.domain = config.ws_path;
        this.fetch = this.fetch.bind(this);
        this.login = this.login.bind(this);
        this.getProfile = this.getProfile.bind(this);
        this.logout = this.logout.bind(this);
    }

    login(email, pwd) {
        return axios.post(this.domain + '/public/authentication' + this.debugMode, {
            email: email,
            pwd: pwd
        }).then(res => {
            this.setToken(res.headers['x-mep']);
            return Promise.resolve(res);
        })
    }

    isLoggedIn() {
        return this.getToken() && !this.isTokenExpired(this.getToken());
    }

    isTokenExpired(token) {

        let end = token.length;
        try {
            const decoded = decode(token.substring(8, end));
            return (decoded.exp < Date.now() / 1000);
        } catch (err) {
            return false;
        }
    }

    setToken(idToken) {
        localStorage.setItem('jwt_token', idToken);
    }

    getToken() {
        return localStorage.getItem('jwt_token');
    }

    logout() {
        localStorage.removeItem('jwt_token');
    }

    getProfile() {
        let token = this.getToken();
        if (!token)
            return null;
        let end = token.length;
        return decode(token.substring(8, end));
    }


    fetch(url, options, formData) {

        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (this.isLoggedIn()) {
            headers['X-Mep'] = this.getToken()
        }

        if (formData) {
            headers['Content-Type'] = 'multipart/form-data';

            return axios.post(this.domain + url + this.debugMode, formData, {
                headers
            }).then(response => {
                this.setToken(response.headers['x-mep']);
                return response;
            });
        }


        return axios(this.domain + url + this.debugMode, {
            headers,
            ...options
        }).then(response => {
            this.setToken(response.headers['x-mep']);
            return response;
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/AuthService.js